








import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import defaultBanner from "../../../../images/homebackground.jpg";
import "../../Subscriptionmanagment/Food/Landing.css";
import {
    getAllBanners,
    addBanner,
    updateBanner,
    deleteBanner,
} from "../../../Servicefile/bannerService.jsx";


// Inline loader hook (same as User Management)
const useInlineLoader = () => {
    const [loading, setLoading] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);

    const showLoader = () => {
        setFadeOut(false);
        setLoading(true);
    };

    const hideLoader = () => {
        setFadeOut(true);
        setTimeout(() => {
            setLoading(false);
            setFadeOut(false);
        }, 500);
    };

    return { showLoader, hideLoader, loading, fadeOut };
};

const Landingbanner = () => {
    const [openPopup, setOpenPopup] = useState(false);

    // Popup Fields
    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    const [editId, setEditId] = useState(null);

    // Image fields
    const [bannerFile, setBannerFile] = useState(null);
    const [image1, setImage1] = useState(null);
    const [image2, setImage2] = useState(null);
    const [image3, setImage3] = useState(null);
    const [image4, setImage4] = useState(null);

    // Banner List (preview)
    const [banners, setBanners] = useState([
        {
            id: 1,
            src: defaultBanner,
            type: "image",
            title: "Welcome to Maamaas",
            desc: "Experience gourmet flavors"
        }
    ]);

    // Use inline loader
    const { showLoader, hideLoader, loading, fadeOut } = useInlineLoader();

    // Slider settings
    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: "ease-in-out",
        arrows: false,
    };

    useEffect(() => {
        const fetchBanner = async () => {
            try {
                showLoader();

                const token =
                    localStorage.getItem("authToken");

                // 🔥 SERVICE API
                const apiData =
                    await getAllBanners(token);

                if (
                    !Array.isArray(apiData) ||
                    apiData.length === 0
                ) {
                    console.warn("No banner found!");
                    hideLoader();
                    return;
                }

                const bannerData = apiData[0];

                setIsEditMode(true);

                setEditId(bannerData.id);

                setTitle(
                    bannerData.companyName || ""
                );

                setDesc(
                    bannerData.description || ""
                );

                const images = [
                    bannerData.banner,
                    bannerData.image1,
                    bannerData.image2,
                    bannerData.image3,
                    bannerData.image4,
                ];

                const bannerList = images
                    .filter((img) => img)
                    .map((img, index) => ({
                        id: `${bannerData.id}-${index}`,
                        src: img,
                        title:
                            bannerData.companyName || "",
                        desc:
                            bannerData.description || "",
                    }));

                setBanners(bannerList);

            } catch (error) {
                console.error(
                    "GET Banner API Error:",
                    error
                );
            } finally {
                hideLoader();
            }
        };

        fetchBanner();
    }, []);

    const handleSave = async () => {
        const adminUserId =
            localStorage.getItem("userId");

        const token =
            localStorage.getItem("authToken");

        if (!bannerFile) {
            alert("Please upload a banner!");
            return;
        }

        showLoader();

        const formData = new FormData();

        const dataObject = {
            description: desc,
            companyName: title,
            adminUserId: Number(adminUserId),
        };

        formData.append(
            "data",
            new Blob(
                [JSON.stringify(dataObject)],
                {
                    type: "application/json",
                }
            )
        );

        formData.append("banner", bannerFile);

        try {

            // 🔥 SERVICE API
            await addBanner(
                formData,
                token
            );

            alert(
                "Banner added successfully!"
            );

            window.location.reload();

            setOpenPopup(false);

        } catch (error) {
            console.error(error);

            alert("Failed to add!");

        } finally {
            hideLoader();
        }
    };

    const handleUpdate = async () => {
        const token =
            localStorage.getItem("authToken");

        const adminUserId =
            localStorage.getItem("userId");

        if (!editId) {
            alert("Invalid banner ID!");
            return;
        }

        showLoader();

        const formData = new FormData();

        const dataObject = {
            description: desc,
            companyName: title,
            adminUserId: Number(adminUserId),
        };

        formData.append(
            "data",
            new Blob(
                [JSON.stringify(dataObject)],
                {
                    type: "application/json",
                }
            )
        );

        if (bannerFile) {
            formData.append(
                "banner",
                bannerFile
            );
        }

        if (image1) {
            formData.append("image1", image1);
        }

        if (image2) {
            formData.append("image2", image2);
        }

        if (image3) {
            formData.append("image3", image3);
        }

        try {

            // 🔥 SERVICE API
            await updateBanner(
                editId,
                formData,
                token
            );

            alert(
                "Banner Updated Successfully!"
            );

            window.location.reload();

            setOpenPopup(false);

        } catch (error) {
            console.error(
                "Update Error:",
                error
            );

            alert(
                "Update Failed: " +
                (error.response?.data?.message ||
                    "Server Error")
            );

        } finally {
            hideLoader();
        }
    };

    // DELETE BANNER LOCALLY ONLY
    const handleDelete = async () => {
        if (!editId) {
            alert(
                "No banner found to delete!"
            );

            return;
        }

        const confirmDelete =
            window.confirm(
                "Are you sure you want to delete this banner?"
            );

        if (!confirmDelete) return;

        showLoader();

        try {
            const token =
                localStorage.getItem("authToken");

            // 🔥 SERVICE API
            await deleteBanner(
                editId,
                token
            );

            alert(
                "Banner deleted successfully!"
            );

            window.location.reload();

            // Reset UI
            setBanners([]);

            setIsEditMode(false);

            setTitle("");

            setDesc("");

            setEditId(null);

        } catch (error) {
            console.error(
                "Delete Error:",
                error
            );

            alert(
                "Failed to delete banner!"
            );

        } finally {
            hideLoader();
        }
    };

    return (
        <div className="container-fluid">
            {/* Global Loader (same as User Management) */}
            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,0.95)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 999999,
                    transition: 'opacity 0.4s ease',
                    fontFamily: 'Arial, sans-serif',
                    opacity: fadeOut ? 0 : 1,
                    pointerEvents: fadeOut ? 'none' : 'auto'
                }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            fontSize: '2rem',
                            fontWeight: 900,
                            letterSpacing: '6px',
                            marginBottom: '30px',
                        }}>
                            {"MAAMAAS".split("").map((l, i) => (
                                <span
                                    key={i}
                                    style={{
                                        display: 'inline-block',
                                        opacity: 0,
                                        transform: 'translateY(30px)',
                                        animation: `letterAnim 0.8s ease forwards ${i * 0.1}s`,
                                        color: '#e50914',
                                    }}
                                >
                                    {l}
                                </span>
                            ))}
                        </div>

                        <div style={{
                            width: '280px',
                            height: '4px',
                            background: 'rgba(255,255,255,0.2)',
                            overflow: 'hidden',
                            margin: '0 auto',
                        }}>
                            <div style={{
                                width: '40%',
                                height: '100%',
                                background: 'linear-gradient(90deg,#e50914,#ff6b6b)',
                                animation: 'progress 1.8s infinite',
                            }}></div>
                        </div>

                        <div style={{
                            marginTop: '20px',
                            color: '#aaa',
                            fontSize: '14px',
                        }}>
                            Loading banner data...
                        </div>
                    </div>
                </div>
            )}

            <div className="row">
                <div className="col-lg-8 col-md-12 col-sm-12" style={{ marginBottom: "10px" }}>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            position: "relative"
                        }}
                        className="buttons-data"
                    >
                        {/* BUTTONS CONTAINER - FIXED RESPONSIVE POSITIONING */}
                        <div style={{
                            position: "absolute",
                            top: "10px",
                            right: "20px", // Changed from negative value to positive
                            display: "flex",
                            gap: "10px",
                            zIndex: 10
                        }}
                            className="banner-buttons-container"
                        >
                            {/* ADD/EDIT BUTTON */}
                            <button
                                onClick={() => setOpenPopup(true)}
                                style={{
                                    background: "rgb(230 109 51)",
                                    border: "none",
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    color: "#fff",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                }}
                                className="banner-buttons-landing"
                            >
                                {isEditMode ? "✏️ Edit" : "➕ Add"}
                            </button>

                            {/* DELETE BUTTON */}
                            <button
                                onClick={handleDelete}
                                style={{
                                    background: "rgb(230 109 51)",
                                    border: "none",
                                    padding: "10px 10px",
                                    borderRadius: "8px",
                                    color: "#fff",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                }}
                                className="banner-buttons-delete"
                            >
                                🗑
                            </button>
                        </div>

                        {/* SLIDER */}
                        <div className="sliderWrapper">
                            <Slider {...settings}>
                                {banners.map((item, index) => (
                                    <div key={index} style={styles.slideItem}>
                                        <div style={styles.imageContainer}>
                                            <img src={item.src} style={styles.image} alt="banner" />

                                            <div style={styles.overlay}>
                                                <h2 style={styles.overlayText}>{item.title}</h2>
                                                <p style={styles.overlaySubText}>{item.desc}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>

                            {/* CSS */}
                            <style>
                                {`
                                    .sliderWrapper {
                                        margin: 0 auto;
                                    }

                                    @media (min-width: 1000px) {
                                        .sliderWrapper {
                                            width: 63vw !important;
                                        }
                                    }

                                    @media (max-width: 1000px) {
                                        .sliderWrapper {
                                            width: 100vw !important;
                                        }
                                    }

                                    .sliderWrapper img {
                                        height: 400px;
                                        object-fit: cover;
                                        border-radius: 12px;
                                        display: block;
                                    }

                                    .slick-slide > div {
                                        display: flex !important;
                                    }

                                    .slick-track {
                                        display: flex !important;
                                        align-items: center !important;
                                    }
                                `}
                            </style>
                        </div>

                        {/* POPUP */}
                        {openPopup && (
                            <div style={styles.popupOverlay}>
                                <div style={styles.popupContainer}>
                                    <span
                                        onClick={() => setOpenPopup(false)}
                                        style={{
                                            display: "block",
                                            fontSize: "20px",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            color: "#444",
                                            textAlign: "right"
                                        }}
                                    >
                                        ✖
                                    </span>

                                    <input
                                        type="text"
                                        placeholder="Enter Title"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                        style={styles.input}
                                    />

                                    <textarea
                                        placeholder="Enter Description"
                                        value={desc}
                                        onChange={(e) => setDesc(e.target.value)}
                                        style={styles.textarea}
                                    ></textarea>

                                    <label style={{ fontWeight: "bold" }}>Upload Banner</label>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => setBannerFile(e.target.files[0])}
                                        className="popupInput"
                                    />

                                    <label style={{ fontWeight: "bold", marginTop: "10px" }}>Image 1</label>
                                    <input type="file" accept="image/*" onChange={(e) => setImage1(e.target.files[0])} className="popupInput" />

                                    <label style={{ fontWeight: "bold", marginTop: "10px" }}>Image 2</label>
                                    <input type="file" accept="image/*" onChange={(e) => setImage2(e.target.files[0])} className="popupInput" />

                                    <label style={{ fontWeight: "bold", marginTop: "10px" }}>Image 3</label>
                                    <input type="file" accept="image/*" onChange={(e) => setImage3(e.target.files[0])} className="popupInput" style={{ marginBottom: "10px" }} />
                                    <br></br>

                                    <button
                                        onClick={isEditMode ? handleUpdate : handleSave}
                                        style={styles.saveBtn}
                                    >
                                        {isEditMode ? "Update" : "Save"}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="col-lg-2 col-md-12 col-sm-12"></div>
            </div>

            {/* Add loader animations to existing style */}
            <style>{`
                @keyframes letterAnim {
                    0% { opacity: 0; transform: translateY(30px); }
                    100% { opacity: 1; transform: translateY(0); }
                }

                @keyframes progress {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(250%); }
                }
                
                /* Fixed responsive styles for buttons */
                .banner-buttons-container {
                    right: 20px !important;
                }
                
                @media (max-width: 1200px) {
                    .banner-buttons-container {
                        right: 15px !important;
                    }
                }
                
                @media (max-width: 768px) {
                    .banner-buttons-container {
                        right: 10px !important;
                        top: 5px !important;
                    }
                    
                    .banner-buttons-landing {
                        padding: 8px 15px !important;
                        font-size: 14px !important;
                    }
                    
                    .banner-buttons-delete {
                        padding: 8px 8px !important;
                        font-size: 14px !important;
                    }
                }
                
                @media (max-width: 480px) {
                    .banner-buttons-container {
                        right: 5px !important;
                        gap: 5px !important;
                    }
                    
                    .banner-buttons-landing {
                        padding: 6px 10px !important;
                        font-size: 12px !important;
                    }
                    
                    .banner-buttons-delete {
                        padding: 6px 6px !important;
                        font-size: 12px !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default Landingbanner;

/* ============ INLINE STYLES ============= */
const styles = {
    slideItem: { position: "relative" },
    imageContainer: {
        position: "relative",
        overflow: "hidden",
        borderRadius: 12,
    },
    image: {
        width: "100%",
    },
    overlay: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
        color: "#fff",
        backgroundColor: "rgba(0,0,0,0.3)",
        padding: "15px 20px",
        borderRadius: 10,
    },
    overlayText: { margin: 0 },
    overlaySubText: { margin: 0 },
    popupOverlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
    },
    popupContainer: {
        width: "350px",
        background: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0px 4px 20px rgba(0,0,0,0.2)",
    },
    input: {
        width: "100%",
        padding: "10px",
        marginBottom: "12px",
        borderRadius: "6px",
        border: "1px solid #ccc",
    },
    textarea: {
        width: "100%",
        padding: "10px",
        height: "70px",
        borderRadius: "6px",
        border: "1px solid #ccc",
    },
    saveBtn: {
        background: "rgb(230 109 51)",
        color: "#fff",
        border: "none",
        padding: "10px",
        borderRadius: "6px",
        cursor: "pointer",
        width: "100%",
        fontWeight: "bold",
    },
};